import { Col, Form, Row } from "antd";
import { DetalleInventarioInicialDiv } from "./DetalleInventarioInicialDiv";
import { AlmacenEmpleadoSelect } from "../reusable/AlmacenEmpleadoSelect";
import { useSelector } from "react-redux";
import { PeriodosContablesSelect } from "../periodocontable/reusable/PeriodosContablesSelect";
import { FormItemHiddenUi } from "../../ui";

export const InventarioInicialForm = () => {
  const { activeEmpleado } = useSelector((state) => state.auth);
  return (
    <>
      <FormItemHiddenUi name="id" />
      <FormItemHiddenUi name="estado" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={12} lg={10} xl={8}>
          <Form.Item
            name="periodo"
            label="Periodo contable"
            rules={[
              { required: true, message: "El periodo contable es obligatorio" },
            ]}
          >
            <PeriodosContablesSelect placeholder="Seleccione periodo contable" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={6}>
          <Form.Item
            name="almacen"
            label="Almacén"
            rules={[{ required: true, message: "Seleccione almacen" }]}
          >
            <AlmacenEmpleadoSelect
              empleado={activeEmpleado?.id}
              placeholder="Seleccione almacén"
            />
          </Form.Item>
        </Col>
      </Row>
      <DetalleInventarioInicialDiv />
    </>
  );
};
